import { HistoryPeriodEnumKeys } from '@libs/types';

export const historyPeriodLabels: Partial<
  Record<HistoryPeriodEnumKeys, string>
> = {
  [HistoryPeriodEnumKeys.ONE_DAY]: 'time_24_hours',
  [HistoryPeriodEnumKeys.ONE_WEEK]: 'time_one_week_short',
  [HistoryPeriodEnumKeys.ONE_MONTH]: 'time_one_month_short',
  [HistoryPeriodEnumKeys.SIX_MONTHS]: 'time_six_month_short',
  [HistoryPeriodEnumKeys.ONE_YEAR]: 'time_one_year_short',
};
